import { Utilities } from "./UtilityService";
// import CryptoJS from "crypto-js";
import { config } from "./config";



export const dataService = {
  GetHomePageData,
  SubmitUserData,
};

async function GetHomePageData(req) {
  try {
    const res = await fetch(config.apiUrl + `/api/get-home-page-detail`, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        "cache-control": "no-cache",
        "Authorization" : `Bearer ` + config.decryptToken,
      },
      body: JSON.stringify(req),
    });
    if (res.status === 200) {
      return res.json();
    } else {
      //        console.log("Login failed");
    }
  } catch (ex) {
    console.log(ex);
  }
}

async function SubmitUserData(req) {
  const requestOptions = {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "cache-control": "no-cache",
      // 'Authorization': "Bearer " + token,
    },
    // credentials: 'include',
    body: JSON.stringify(req),
  };

  return fetch(config.apiUrl + "/api/send-email", requestOptions)
    .then((res) => res.json())
    .then((result) => {
      return result;
    });
}

